module.exports = __webpack_public_path__ + "img/1970East-078_WEB-min.61ed2633.jpg";